//
// Core Cost Layer Fields & Relations
// =====
export enum ECostLayerField {
  COST_UNIT = 'costPerUnit',
  COST_TOTAL = 'totalCost',
  DATE_CREATED = 'createdAt',
  DATE_DELETED = 'deletedAt',
  DATE_UPDATED = 'updatedAt',
  ID = 'id',
  IS_VARIANCE = 'isVariance',
  LOT = 'lot',
  LOT_ID = 'lotId',
  LOT_NUMBER = 'lot.lotNumber',
  LOT_NUMBER_LEGACY = 'lotNumber', // unused when utah-UTAH-271-cost_layer_serverside_multisort is `true`
  PRODUCT = 'product',
  PRODUCT_ID = 'productId',
  PRODUCT_NAME = 'product.productName',
  PRODUCT_SKU = 'product.internalSku',
  QUANTITY_INITIAL = 'initialQuantity',
  QUANTITY_REMAINING = 'remainingQuantity',
  WAREHOUSE = 'warehouse',
  WAREHOUSE_ID = 'warehouseId',
  WAREHOUSE_NAME = 'warehouse.locationName',
  WAREHOUSE_NAME_LEGACY = 'locationName', // unused when utah-UTAH-271-cost_layer_serverside_multisort is `true`
  COST_QUANTITY_REMAINING = 'remainingQuantityCost',
}

export enum ECostLayerRelation {
  COST_LAYER_CHANGES = 'costLayerChanges',
  LOT = 'lot',
  PRODUCT = 'product',
  PURCHASE_ORDER = 'purchaseOrder',
  RECEIPT = 'receipt',
  SHIPMENT = 'shipment',
  WAREHOUSE = 'warehouse',
}

export const CostLayersKeyByField :Partial<Record<ECostLayerField, string>> = {
  [ECostLayerField.LOT_NUMBER]: 'lotNumber',
  [ECostLayerField.PRODUCT_NAME]: 'productName',
  [ECostLayerField.PRODUCT_SKU]: 'productSku',
  [ECostLayerField.WAREHOUSE_NAME]: 'warehouseName',
} as const;

export const COST_LAYERS_API_DEFAULT_RELATIONS = [
  ECostLayerRelation.LOT,
  ECostLayerRelation.PRODUCT,
  ECostLayerRelation.WAREHOUSE,
  ECostLayerRelation.PURCHASE_ORDER,
  ECostLayerRelation.RECEIPT,
  ECostLayerRelation.SHIPMENT,
];

//
// Costing Configuration
// =====
export enum ECostingType {
  FIFO = 'fifo',
  WEIGHTED_AVERAGE = 'weighted_average',
}

//
// Change Tracking
// =====
export enum ECostLayerChangesLogLayout {
  AUDIT = 'AUDIT',
  SALES = 'SALES',
}

export enum ECostLayerChangesSubset {
  ALL = 'ALL',
  QUANTITY = 'QUANTITY',
}

export const isECostLayerChangesSubset = (
  candidate :any,
) :candidate is ECostLayerChangesSubset =>
  Object.values(ECostLayerChangesSubset).includes(candidate);

export const CostLayerChangesParamsBySubset :Record<
  ECostLayerChangesSubset,
  HttpParamsHash
> = {
  [ECostLayerChangesSubset.ALL]: {},
  [ECostLayerChangesSubset.QUANTITY]: {
    'quantityChange[neq]': '0',
  },
} as const;

export enum ECostLayerChangeTransactionType {
  ADJUSTMENT = 'adjustment',
  ASSEMBLY_ORDER = 'assembly_order',
  DISASSEMBLY_ORDER = 'disassembly_order',
  IMPORT = 'import',
  MANUAL = 'manual_edit',
  PICKLIST = 'picklist',
  RECEIPT = 'receipt',
  SALES_ORDER = 'sales_order',
  STOCK_PULL = 'stock_pull',
}

//
// Misc
// =====
